import React, { useState } from "react";

export default function Checkbox({
	onChange,
	label = "Check me!",
	className,
	checked,
	name,
	disabled,
}) {
	const [isChecked, setIsChecked] = useState(false);

	const handleCheckboxChange = (event) => {
		setIsChecked(!isChecked);
		onChange(event);
	};

	// console.log({ isChecked });
	return (
		<div className="p-4">
			<label className="flex items-center space-x-2">
				<input
					name={name}
					type="checkbox"
					className={`form-checkbox h-4 w-4 text-indigo-600 focus:ring focus:ring-indigo-200 ${className}`}
					checked={checked}
					disabled={disabled}
					onChange={handleCheckboxChange}
				/>
				<span className="text-sm text-gray-700 font-bold">{label}</span>
			</label>
		</div>
	);
}
